module.exports = __webpack_public_path__ + "static/media/12.5b7a13fd.jpg";